import { Typography, Button, Grid } from '@mui/material';

import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { useModalStore } from '../../../zustandStore/store.attributes';

function PageHeader() {
  const store = useModalStore((state) => state);
  const action = store.actions;
  const user = {
    name: 'Tags for Prizeet',
    avatar: '/static/images/avatars/1.jpg'
  };
  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item>
        <Typography variant="h3" component="h3" gutterBottom>
          Tags
        </Typography>
        <Typography variant="subtitle2">
          {user.name}, these are your recent tags
        </Typography>
      </Grid>
      <Grid item>
        <Button
          sx={{ mt: { xs: 2, md: 0 } }}
          variant="contained"
          onClick={(e) =>
            action.setModal({
              modalOpen: true
            })
          }
          startIcon={<AddTwoToneIcon fontSize="small" />}
        >
          Create Tags
        </Button>
      </Grid>
    </Grid>
  );
}

export default PageHeader;
